<template>
  <div class="kkday-order-page">
    <!-- 页面标题 -->
    <div class="page-header">
      <h2>Kkday 订单管理</h2>
    </div>

    <!-- 筛选表单 -->
    <el-card class="filter-card" shadow="never">
      <el-form :inline="true" :model="filters" class="filter-form" size="small">
        <el-form-item label="搜索">
          <el-input
            v-model="filters.search"
            placeholder="订单号/SN/买家邮箱"
            clearable
            style="width: 200px"
            @clear="handleSearch"
          >
            <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="订单状态">
          <el-select v-model="filters.status" placeholder="全部" clearable style="width: 120px">
            <el-option label="待支付" value="pending"></el-option>
            <el-option label="已支付" value="paid"></el-option>
            <el-option label="已取消" value="cancelled"></el-option>
            <el-option label="已退款" value="refunded"></el-option>
            <el-option label="已完成" value="completed"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支付状态">
          <el-select v-model="filters.pay_status" placeholder="全部" clearable style="width: 120px">
            <el-option label="未支付" value="unpaid"></el-option>
            <el-option label="已支付" value="paid"></el-option>
            <el-option label="退款中" value="refunding"></el-option>
            <el-option label="已退款" value="refunded"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单分类">
          <el-select v-model="filters.category" placeholder="全部" clearable style="width: 120px">
            <el-option label="客户下单" value="customer"></el-option>
            <el-option label="活动赠送" value="gift"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建日期">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            style="width: 240px"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          <el-button icon="el-icon-refresh-left" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 订单列表 -->
    <el-card class="table-card" shadow="never">
      <el-table
        :data="orderList"
        v-loading="loading"
        border
        stripe
        style="width: 100%"
        size="small"
      >
        <el-table-column prop="id" label="ID" width="70" align="center"></el-table-column>
        <el-table-column prop="sn" label="订单流水号" width="170">
          <template slot-scope="scope">
            <span class="copyable" @click="copyToClipboard(scope.row.sn, '订单流水号')">
              {{ scope.row.sn || '-' }}
            </span>
            <i class="el-icon-copy-document copy-icon" @click="copyToClipboard(scope.row.sn, '订单流水号')" v-if="scope.row.sn"></i>
          </template>
        </el-table-column>
        <el-table-column prop="order_no" label="Kkday订单号" width="180">
          <template slot-scope="scope">
            <span class="copyable" @click="copyToClipboard(scope.row.order_no, 'Kkday订单号')">
              {{ scope.row.order_no || '-' }}
            </span>
            <i class="el-icon-copy-document copy-icon" @click="copyToClipboard(scope.row.order_no, 'Kkday订单号')" v-if="scope.row.order_no"></i>
          </template>
        </el-table-column>
        <el-table-column label="产品信息" min-width="180">
          <template slot-scope="scope">
            <div class="product-info">
              <div class="product-name">{{ (scope.row.product && scope.row.product.prod_name) || '-' }}</div>
              <div class="package-name">{{ (scope.row.package && scope.row.package.pkg_name) || '-' }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="prod_no" label="产品编号" width="90"></el-table-column>
        <el-table-column prop="pkg_no" label="套餐编号" width="90"></el-table-column>
        <el-table-column label="使用日期" width="160">
          <template slot-scope="scope">
            <div>{{ scope.row.s_date }}</div>
            <div class="text-secondary">{{ scope.row.e_date }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="num" label="数量" width="70" align="center"></el-table-column>
        <el-table-column label="用户信息" width="160">
          <template slot-scope="scope">
            <div v-if="scope.row.user" class="user-info">
              <div class="user-nickname">ID: {{ scope.row.user.id }} {{ scope.row.user.nickname || '-' }}</div>
              <div class="user-contact">{{ scope.row.user.mail || scope.row.user.tel || '-' }}</div>
            </div>
            <span v-else style="color: #909399">-</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="90" align="center">
          <template slot-scope="scope">
            <div>{{ (scope.row.sts && scope.row.sts.StatusLabel) || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Kkday状态" width="110" align="center">
          <template slot-scope="scope">
            <div class="status-text">{{ (scope.row.sts && scope.row.sts.KkStatusLabel) || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Kkday取消" width="110" align="center">
          <template slot-scope="scope">
            <div class="status-text">{{ (scope.row.sts && scope.row.sts.KkCancelStatusLabel) || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Kk价格" width="90" align="right">
          <template slot-scope="scope">
            <span class="price-b2b">¥{{ scope.row.total_price }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单价格" width="90" align="right">
          <template slot-scope="scope">
            <span class="price-text">¥{{ scope.row.b2c_total_price }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单分类" width="110" align="center">
          <template slot-scope="scope">
            <el-select
              :value="scope.row.category || 'customer'"
              size="mini"
              style="width: 90px"
              :loading="categoryLoadingSn === scope.row.sn"
              :disabled="categoryLoadingSn === scope.row.sn"
              @change="(val) => handleCategoryChange(scope.row, val)"
            >
              <el-option label="客户下单" value="customer"></el-option>
              <el-option label="活动赠送" value="gift"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="Kkday退款" width="100" align="right">
          <template slot-scope="scope">
            <span class="price-refund">{{ scope.row.kk_refund_money || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="取消原因" min-width="140">
          <template slot-scope="scope">
            <div v-if="scope.row.cancel_type" class="cancel-info-cell">
              <el-tag type="info" size="mini">{{ scope.row.cancel_type }}</el-tag>
              <el-popover
                v-if="scope.row.cancel_desc"
                placement="top"
                width="300"
                trigger="hover"
              >
                <div style="white-space: pre-wrap;">{{ scope.row.cancel_desc }}</div>
                <div slot="reference" class="cancel-desc">
                  {{ truncateText(scope.row.cancel_desc, 15) }}
                </div>
              </el-popover>
            </div>
            <span v-else style="color: #909399">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" width="155"></el-table-column>
        <el-table-column label="操作" width="200" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="viewDetail(scope.row)">详情</el-button>
            <el-button
              v-if="canMarkPaid(scope.row)"
              type="text"
              size="small"
              class="mark-paid-btn"
              @click="handleMarkPaid(scope.row)"
            >已付款</el-button>
            <el-button
              v-if="scope.row.refund_status === 'pending'"
              type="text"
              size="small"
              @click="handleProcessRefund(scope.row)"
            >处理退款</el-button>
            <el-button
              v-if="scope.row.refund_status === 'failed'"
              type="text"
              size="small"
              @click="handleRetryRefund(scope.row)"
            >重试</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.current_page"
          :page-sizes="[10, 15, 20, 50, 100]"
          :page-size="pagination.per_page"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </el-card>

    <!-- 订单详情弹窗 -->
    <el-dialog
      title="订单详情"
      :visible.sync="detailDialogVisible"
      width="800px"
      :close-on-click-modal="false"
    >
      <div v-if="currentOrder" class="order-detail">
        <!-- 基础信息 -->
        <div class="detail-section">
          <h3 class="section-title">基础信息</h3>
          <el-descriptions :column="2" border size="small">
            <el-descriptions-item label="订单ID">{{ currentOrder.id }}</el-descriptions-item>
            <el-descriptions-item label="订单流水号">{{ currentOrder.sn }}</el-descriptions-item>
            <el-descriptions-item label="Kkday订单号" :span="2">{{ currentOrder.order_no || '-' }}</el-descriptions-item>
            <el-descriptions-item label="订单状态">
              <el-tag :type="getOrderStatusType(currentOrder.order_status)" size="small">
                {{ getOrderStatusText(currentOrder.order_status) }}
              </el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="订单分类">
              <el-tag :type="getCategoryType(currentOrder.category)" size="small">
                {{ getCategoryText(currentOrder.category) }}
              </el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="产品编号">{{ currentOrder.prod_no }}</el-descriptions-item>
            <el-descriptions-item label="套餐编号">{{ currentOrder.pkg_no }}</el-descriptions-item>
            <el-descriptions-item label="数量">{{ currentOrder.num }}</el-descriptions-item>
            <el-descriptions-item label="使用开始日期">{{ currentOrder.s_date }}</el-descriptions-item>
            <el-descriptions-item label="使用结束日期">{{ currentOrder.e_date }}</el-descriptions-item>
            <el-descriptions-item label="Kk价格">¥{{ currentOrder.total_price }}</el-descriptions-item>
            <el-descriptions-item label="订单价格">¥{{ currentOrder.b2c_total_price }}</el-descriptions-item>
            <el-descriptions-item label="创建时间">{{ currentOrder.created_at }}</el-descriptions-item>
            <el-descriptions-item label="是否可取消">
              <el-tag :type="currentOrder.can_cancel ? 'success' : 'info'" size="small">
                {{ currentOrder.can_cancel ? '是' : '否' }}
              </el-tag>
            </el-descriptions-item>
          </el-descriptions>
        </div>

        <!-- 用户信息 -->
        <div class="detail-section" v-if="currentOrder.user">
          <h3 class="section-title">用户信息</h3>
          <el-descriptions :column="2" border size="small">
            <el-descriptions-item label="用户ID">{{ currentOrder.user.id }}</el-descriptions-item>
            <el-descriptions-item label="昵称">{{ currentOrder.user.nickname || '-' }}</el-descriptions-item>
            <el-descriptions-item label="邮箱">{{ currentOrder.user.mail || '-' }}</el-descriptions-item>
            <el-descriptions-item label="手机">{{ currentOrder.user.tel || '-' }}</el-descriptions-item>
          </el-descriptions>
        </div>

        <!-- 产品信息 -->
        <div class="detail-section" v-if="currentOrder.product">
          <h3 class="section-title">产品信息</h3>
          <el-descriptions :column="1" border size="small">
            <el-descriptions-item label="产品名称">{{ currentOrder.product.prod_name }}</el-descriptions-item>
            <el-descriptions-item label="产品图片">
              <div class="image-list">
                <el-image
                  v-for="(img, index) in currentOrder.product.img_list"
                  :key="index"
                  :src="img"
                  :preview-src-list="currentOrder.product.img_list"
                  fit="cover"
                  style="width: 60px; height: 60px; margin-right: 10px"
                ></el-image>
              </div>
            </el-descriptions-item>
          </el-descriptions>
        </div>

        <!-- 套餐信息 -->
        <div class="detail-section" v-if="currentOrder.package">
          <h3 class="section-title">套餐信息</h3>
          <el-descriptions :column="1" border size="small">
            <el-descriptions-item label="套餐编号">{{ currentOrder.package.pkg_no }}</el-descriptions-item>
            <el-descriptions-item label="套餐名称">{{ currentOrder.package.pkg_name }}</el-descriptions-item>
          </el-descriptions>
        </div>

        <!-- 退款信息 -->
        <div class="detail-section" v-if="currentOrder.refund_status && currentOrder.refund_status !== 'none'">
          <h3 class="section-title">退款信息</h3>
          <el-descriptions :column="2" border size="small">
            <el-descriptions-item label="退款状态">
              <el-tag :type="getRefundStatusType(currentOrder.refund_status)" size="small">
                {{ getRefundStatusText(currentOrder.refund_status) }}
              </el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="退款金额">
              <span v-if="currentOrder.refund_money && parseFloat(currentOrder.refund_money) > 0" class="refund-money">
                ¥{{ currentOrder.refund_money }}
              </span>
              <span v-else>-</span>
            </el-descriptions-item>
            <el-descriptions-item label="取消原因代码">
              <el-tag v-if="currentOrder.cancel_type" type="info" size="small">
                {{ currentOrder.cancel_type }}
              </el-tag>
              <span v-else>-</span>
            </el-descriptions-item>
            <el-descriptions-item label="取消原因说明" :span="2">
              <span v-if="currentOrder.cancel_desc">{{ currentOrder.cancel_desc }}</span>
              <span v-else>-</span>
            </el-descriptions-item>
          </el-descriptions>
        </div>

        <!-- 凭证信息 -->
        <div class="detail-section" v-if="currentOrder.vouchers && currentOrder.vouchers.length > 0">
          <h3 class="section-title">凭证信息</h3>
          <el-table :data="currentOrder.vouchers" border size="small">
            <el-table-column prop="voucher_no" label="凭证号" width="200"></el-table-column>
            <el-table-column prop="status" label="状态" width="100">
              <template slot-scope="scope">
                <el-tag :type="scope.row.status === 'valid' ? 'success' : 'danger'" size="small">
                  {{ scope.row.status === 'valid' ? '有效' : '无效' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="二维码" width="100">
              <template slot-scope="scope">
                <el-image
                  v-if="scope.row.qr_code"
                  :src="scope.row.qr_code"
                  :preview-src-list="[scope.row.qr_code]"
                  fit="cover"
                  style="width: 40px; height: 40px"
                ></el-image>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 扩展信息 -->
        <div class="detail-section" v-if="currentOrder.extra">
          <h3 class="section-title">扩展信息</h3>
          <pre class="json-viewer">{{ JSON.stringify(currentOrder.extra, null, 2) }}</pre>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { kkdayOrderApi } from '@/api/index.js';

export default {
  name: 'KkdayOrder',
  data() {
    return {
      loading: false,
      orderList: [],
      filters: {
        page: 1,
        per_page: 15,
        status: '',
        pay_status: '',
        category: '',
        start_date: '',
        end_date: '',
        search: ''
      },
      dateRange: [],
      pagination: {
        current_page: 1,
        per_page: 15,
        total: 0,
        last_page: 1
      },
      detailDialogVisible: false,
      currentOrder: null,
      categoryLoadingSn: ''
    };
  },
  created() {
    this.fetchOrderList();
  },
  methods: {
    // 获取订单列表
    async fetchOrderList() {
      this.loading = true;
      try {
        const params = { ...this.filters };
        if (this.dateRange && this.dateRange.length === 2) {
          params.start_date = this.dateRange[0];
          params.end_date = this.dateRange[1];
        } else {
          delete params.start_date;
          delete params.end_date;
        }
        Object.keys(params).forEach(key => {
          if (params[key] === '' || params[key] === null || params[key] === undefined) {
            delete params[key];
          }
        });

        const res = await kkdayOrderApi.getList(params);
        if (res.code === 1) {
          this.orderList = res.data.orders || [];
          this.pagination = res.data.pagination || this.pagination;
        } else {
          this.$message.error(res.message || '获取订单列表失败');
        }
      } catch (error) {
        console.error('获取订单列表失败:', error);
        this.$message.error('获取订单列表失败');
      } finally {
        this.loading = false;
      }
    },

    // 搜索
    handleSearch() {
      this.filters.page = 1;
      this.fetchOrderList();
    },

    // 重置筛选
    handleReset() {
      this.filters = {
        page: 1,
        per_page: this.filters.per_page,
        status: '',
        pay_status: '',
        category: '',
        start_date: '',
        end_date: '',
        search: ''
      };
      this.dateRange = [];
      this.fetchOrderList();
    },

    // 每页数量变化
    handleSizeChange(val) {
      this.filters.per_page = val;
      this.fetchOrderList();
    },

    // 当前页变化
    handleCurrentChange(val) {
      this.filters.page = val;
      this.fetchOrderList();
    },

    // 查看详情
    async viewDetail(row) {
      try {
        const res = await kkdayOrderApi.getDetail(row.sn);
        if (res.code === 1) {
          // 兼容两种数据结构：直接返回订单对象，或嵌套在 base/extra 中
          if (res.data.base) {
            this.currentOrder = { ...res.data.base, extra: res.data.extra };
          } else {
            this.currentOrder = res.data || {};
          }
          this.detailDialogVisible = true;
        } else {
          this.$message.error(res.message || '获取订单详情失败');
        }
      } catch (error) {
        console.error('获取订单详情失败:', error);
        this.$message.error('获取订单详情失败');
      }
    },

    // 是否显示"已付款"按钮（仅待支付/未支付订单显示）
    canMarkPaid(row) {
      if (row.order_status) {
        return row.order_status === 'pending';
      }
      if (row.pay_status) {
        return row.pay_status === 'unpaid';
      }
      const label = row.sts && row.sts.StatusLabel;
      if (label) {
        return label.indexOf('待支付') > -1 || label.indexOf('未支付') > -1;
      }
      return false;
    },

    // 标记为已付款（二次确认，确认后后台自动从Kkday出票）
    handleMarkPaid(row) {
      this.$confirm(
        `是否确认将订单 ${row.sn} 设置为已付款？确认后系统将自动从 Kkday 出票。`,
        '已付款确认',
        {
          confirmButtonText: '确认已付款',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(async () => {
        try {
          const res = await kkdayOrderApi.markPaid({ sn: row.sn });
          if (res.code === 1 || res.success) {
            this.$message.success(res.message || '已标记为已付款，系统正在自动出票');
            this.fetchOrderList();
          } else {
            this.$message.error(res.message || '操作失败');
          }
        } catch (error) {
          console.error('标记已付款失败:', error);
          this.$message.error('标记已付款失败');
        }
      }).catch(() => {});
    },

    // 切换订单分类（customer=客户下单 / gift=活动赠送）
    async handleCategoryChange(row, category) {
      this.categoryLoadingSn = row.sn;
      try {
        const res = await kkdayOrderApi.setCategory({ sn: row.sn, category });
        if (res.code === 1 || res.success) {
          this.$message.success(`已切换为「${this.getCategoryText(category)}」`);
        } else {
          this.$message.error(res.message || '分类切换失败');
          this.fetchOrderList();
        }
      } catch (error) {
        console.error('分类切换失败:', error);
        this.$message.error('分类切换失败');
        this.fetchOrderList();
      } finally {
        this.categoryLoadingSn = '';
      }
    },

    // 订单分类文字（默认客户下单）
    getCategoryText(category) {
      return category === 'gift' ? '活动赠送' : '客户下单';
    },

    // 订单分类标签类型
    getCategoryType(category) {
      return category === 'gift' ? 'warning' : '';
    },

    // 处理退款（审核）
    async handleProcessRefund(row) {
      // 显示退款审核对话框
      this.$msgbox({
        title: '退款审核',
        message: this.$createElement('div', { style: 'padding: 10px 0;' }, [
          this.$createElement('p', { style: 'margin-bottom: 8px; font-weight: bold;' }, `订单号：${row.sn}`),
          this.$createElement('p', { style: 'margin-bottom: 8px;' }, `退款金额：¥${row.refund_money || '0.00'}`),
          this.$createElement('p', { style: 'margin-bottom: 8px;' }, `取消原因：${this.getCancelTypeText(row.cancel_type) || '-'}`),
          this.$createElement('p', { style: 'margin-bottom: 8px; color: #606266;' }, `说明：${row.cancel_desc || '无'}`),
        ]),
        showCancelButton: true,
        confirmButtonText: '批准退款',
        cancelButtonText: '拒绝退款',
        distinguishCancelAndClose: true,
        type: 'warning',
        beforeClose: async (action, instance, done) => {
          if (action === 'confirm') {
            // 批准退款
            instance.confirmButtonText = '处理中...';
            instance.confirmButtonLoading = true;
            try {
              const res = await kkdayOrderApi.processRefund({
                sn: row.sn,
                approve: true
              });
              if (res.code === 1 || res.success) {
                this.$message.success(res.message || '退款处理成功');
                this.fetchOrderList();
                done();
              } else {
                this.$message.error(res.message || '退款处理失败');
                instance.confirmButtonLoading = false;
              }
            } catch (error) {
              console.error('退款处理失败:', error);
              this.$message.error('退款处理失败');
              instance.confirmButtonLoading = false;
            }
          } else if (action === 'cancel') {
            // 拒绝退款
            try {
              const res = await kkdayOrderApi.processRefund({
                sn: row.sn,
                approve: false
              });
              if (res.code === 1 || res.success) {
                this.$message.success(res.message || '已拒绝退款申请');
                this.fetchOrderList();
                done();
              } else {
                this.$message.error(res.message || '操作失败');
              }
            } catch (error) {
              console.error('拒绝退款失败:', error);
              this.$message.error('操作失败');
            }
          } else {
            done();
          }
        }
      }).catch(() => {});
    },

    // 重试失败的退款
    async handleRetryRefund(row) {
      this.$confirm(
        `订单 ${row.sn} 退款失败，是否重试？`,
        '重试退款',
        {
          confirmButtonText: '重试',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(async () => {
        try {
          const res = await kkdayOrderApi.processRefund({
            sn: row.sn,
            approve: true
          });
          if (res.code === 1 || res.success) {
            this.$message.success(res.message || '退款处理成功');
            this.fetchOrderList();
          } else {
            this.$message.error(res.message || '退款处理失败');
          }
        } catch (error) {
          console.error('退款重试失败:', error);
          this.$message.error('退款处理失败');
        }
      }).catch(() => {});
    },

    // 处理退款（旧方法，保留兼容）
    async handleRefund(row) {
      this.handleProcessRefund(row);
    },

    // 复制到剪贴板
    copyToClipboard(text, label) {
      if (!text) return;
      navigator.clipboard.writeText(text).then(() => {
        this.$message.success(`${label}已复制`);
      }).catch(() => {
        this.$message.error('复制失败');
      });
    },

    // 订单状态类型
    getOrderStatusType(status) {
      const typeMap = {
        pending: 'info',
        paid: 'success',
        cancelled: 'warning',
        refunded: 'danger',
        completed: ''
      };
      return typeMap[status] || 'info';
    },

    // 订单状态文字
    getOrderStatusText(status) {
      const textMap = {
        pending: '待支付',
        paid: '已支付',
        cancelled: '已取消',
        refunded: '已退款',
        completed: '已完成'
      };
      return textMap[status] || status;
    },

    // 退款状态类型（返回 Element UI tag 的 type）
    getRefundStatusType(status) {
      const typeMap = {
        none: '',
        pending: 'warning',
        processing: 'info',
        success: 'success',
        failed: 'danger',
        rejected: 'info'
      };
      return typeMap[status] || '';
    },

    // 退款状态文字
    getRefundStatusText(status) {
      const textMap = {
        none: '未申请退款',
        pending: '退款审核中',
        processing: '退款处理中',
        success: '退款成功',
        failed: '退款失败',
        rejected: '退款被拒绝'
      };
      return textMap[status] || status;
    },

    // 截断文本
    truncateText(text, maxLength) {
      if (!text) return '';
      return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
    },

    // 取消原因代码转文字
    getCancelTypeText(code) {
      const typeMap = {
        'MC001': '行程变更或取消',
        'MC002': '重複訂購',
        'MC003': '價格因素',
        'MC004': '個人因素',
        'MC005': '交通因素',
        'MC006': '聯絡不上店家',
        'MC999': '其他'
      };
      return typeMap[code] || code;
    }
  }
};
</script>

<style lang="scss" scoped>
.kkday-order-page {
  padding: 20px;

  .page-header {
    margin-bottom: 20px;

    h2 {
      margin: 0;
      font-size: 20px;
      font-weight: 500;
      color: #303133;
    }
  }

  .filter-card {
    margin-bottom: 20px;

    .filter-form {
      margin-bottom: -10px;

      ::v-deep .el-form-item {
        margin-bottom: 10px;
      }
    }
  }

  .table-card {
    .copyable {
      cursor: pointer;
      color: #409EFF;

      &:hover {
        text-decoration: underline;
      }
    }

    .mark-paid-btn {
      color: #67C23A;
      font-weight: 500;

      &:hover {
        color: #85ce61;
      }
    }

    .copy-icon {
      margin-left: 5px;
      cursor: pointer;
      color: #909399;

      &:hover {
        color: #409EFF;
      }
    }

    .product-info {
      .product-name {
        font-weight: 500;
        color: #303133;
      }

      .package-name {
        font-size: 12px;
        color: #909399;
        margin-top: 4px;
      }
    }

    .user-info {
      .user-nickname {
        font-weight: 500;
        color: #303133;
      }

      .user-contact {
        font-size: 12px;
        color: #909399;
        margin-top: 4px;
      }
    }

    .text-secondary {
      color: #909399;
      font-size: 12px;
    }

    .price-text {
      color: #F56C6C;
      font-weight: 500;
    }

    .price-b2b {
      color: #409EFF;
      font-weight: 500;
    }

    .price-refund {
      color: #E6A23C;
      font-weight: 500;
    }

    .refund-money {
      color: #F56C6C;
      font-weight: 500;
    }

    .refund-info-cell {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 4px;

      .refund-amount {
        color: #F56C6C;
        font-weight: 500;
        font-size: 12px;
      }
    }

    .cancel-info-cell {
      display: flex;
      align-items: center;
      gap: 6px;
      flex-wrap: wrap;
    }

    .cancel-desc {
      cursor: pointer;
      color: #606266;
      font-size: 12px;
      max-width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      &:hover {
        color: #409EFF;
      }
    }

    .status-text {
      font-size: 12px;
    }

    .pagination-container {
      margin-top: 20px;
      text-align: right;
    }
  }

  .order-detail {
    .detail-section {
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }

      .section-title {
        margin: 0 0 15px 0;
        font-size: 16px;
        font-weight: 500;
        color: #303133;
        border-left: 3px solid #409EFF;
        padding-left: 10px;
      }

      .image-list {
        display: flex;
        flex-wrap: wrap;
      }

      .json-viewer {
        background: #f5f7fa;
        padding: 15px;
        border-radius: 4px;
        font-size: 12px;
        overflow-x: auto;
      }
    }
  }
}
</style>
